import React, { useEffect, useState } from 'react'
import Loader from './Loader'
import { Story } from '../types'
import { timeToTimeAgo } from '../HelperFunctions'

interface Props {
	id: number
	toggle: boolean
}

const SingleComment: React.FC<Props> = ({ id, toggle }) => {
	const [comment, setComment] = useState<Story>()
	const [text, setText] = useState('')
	const [isLoading, setIsLoading] = useState(true)

	useEffect(() => {
		const fetchComment = async () => {
			fetch(
				` https://hacker-news.firebaseio.com/v0/item/${id}.json?print=pretty`
			)
				.then((res) => res.json())
				.then((res) => {
					setComment(res)
					setText(res.text)
					setIsLoading(false)
				})
				.catch((error) => console.log(error))
		}
		if (toggle) {
			fetchComment()
		}
	}, [toggle])

	return (
		<li className="single-comment">
			{isLoading ? (
				<Loader />
			) : (
				<div>
					<span>
						Comment by{' '}
						<i className="text-blue remove-decoration">
							{comment?.by}
						</i>
						, {timeToTimeAgo(comment?.time)} ago
					</span>
					{/* ovo ne bi trebalo da se radi ali ovde nema rizika */}
					<p dangerouslySetInnerHTML={{ __html: text }}></p>
				</div>
			)}
		</li>
	)
}

export default SingleComment
